import Moment from "moment";
import formatDateShort from "./date-short";

export default function formatDaterangeShort(start: Moment.Moment, end:Moment.Moment, collapseOneDay:boolean = false):string {

    if (!start || !end) return ''

    // convert to Moment if not moment
    if (!Moment.isMoment(start)) {
        start = Moment(start)
    }

    if (!Moment.isMoment(end)) {
        end = Moment(end)
    }

    // const format: string = (start.year()===Moment().year()) ? 'MMM D' : 'MMM D, YYYY'

    if (collapseOneDay && start.isSame(end, 'days')) {
        return formatDateShort(start, true)
    } else {

        // we never add Year to start date here to make it smaller

        // @ts-ignore
        return "{0} - {1}".f(
            start.format('MMM D'),
            // formatDateShort(start, false),
            formatDateShort(end, false)
        )
    }

}